 /**
 * 操作权限处理
 * Copyright (c) 2024 linsy
 */

export default {
  inserted (el, binding, vnode) {
    let timer = null; // 创建计时器变量
    el.addEventListener('click', () => {
      clearTimeout(timer); // 清除之前的计时器
      timer = setTimeout(() => {
        binding.value(); // 调用传入的函数并将值作为参数传递进去
      }, binding.arg || 300); // 设置默认的延迟时间（单位：ms）
    });
  }
}
